import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Breakpoint } from '@travel-frontend/core';
import { Container } from '../../../../components/Header/components/BottomBar/Container.js';
import { Content } from '../../../../components/Header/components/BottomBar/Content.js';
import { Logo } from '../../../../components/Header/components/BottomBar/Logo.js';
import { PageTitle } from '../../../../components/Header/components/BottomBar/PageTitle.js';
export const BottomBar = ({
  children,
  logo,
  pageTitle
}) => {
  return _jsxs(Container, {
    children: [_jsx(Logo, {
      children: logo
    }), pageTitle && _jsx(Breakpoint, {
      matches: ['md', 'sm', 'xs'],
      children: _jsx(PageTitle, {
        children: pageTitle
      })
    }), _jsx(Content, {
      children: children
    })]
  });
};